/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Customization: Format trademark symbols into superscriptsas soon as possible (on ready) in the list of target selectors
  function formatTrademarkSymbols() {
    const trademarkRegex = /[™®]/g;
    const targetSelectors = [
      '.product-item__title',
      '.product__title',
      '.hero__title',
      '.hero__description',
      '.navtext',
      '.tab-content'
    ];
    
    // Get all matching elements
    const elements = document.querySelectorAll(targetSelectors.join(','));
    
    elements.forEach(element => {
      const textNodes = [];
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(node) {
            return trademarkRegex.test(node.textContent) 
              ? NodeFilter.FILTER_ACCEPT 
              : NodeFilter.FILTER_REJECT;
          }
        },
        false
      );

      let node;
      while (node = walker.nextNode()) {
        textNodes.push(node);
      }

      textNodes.forEach(node => {
        const span = document.createElement('span');
        span.className = 'trademark';
        span.innerHTML = node.textContent.replace(
          trademarkRegex,
          match => `<sup>${match}</sup>`
        );
        node.parentNode.replaceChild(span, node);
      });
    });
  }

  // Run immediately and also on DOMContentLoaded to catch any dynamic content
  formatTrademarkSymbols();
  //document.addEventListener('DOMContentLoaded', formatTrademarkSymbols);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.


  // Customization: Add Collection Product Grid Item Image Switch

  // Collection view mode toggle based on URL query string
  function handleCollectionViewMode() {
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    let mode = urlParams.get('mode');
    
    // Check if we're on a collection page
    const isCollectionPage = document.querySelector('[data-section-type="collection"]') !== null;
    
    if (isCollectionPage) {
      // If no mode in URL, check session storage for saved view mode
      if (!mode) {
        const savedMode = sessionStorage.getItem('currentViewMode');
        if (savedMode && (savedMode === 'model' || savedMode === 'product')) {
          // Automatically apply the saved view mode by updating URL
          const url = new URL(window.location);
          url.searchParams.set('mode', savedMode);
          window.history.replaceState({}, '', url);
          mode = savedMode;
        }
      }
      
      if (mode === 'model') {
        // Add the model view class to the HTML element
        document.body.classList.add('collection-view-model');
      } else if (mode === 'product') {
        // Remove the model view class from the HTML element
        document.body.classList.remove('collection-view-model');
      }
      
      // Update button visibility
      updateViewModeButtons(mode);
    }
  }

  // Update button visibility based on current mode
  function updateViewModeButtons(currentMode) {
    const modelButton = document.querySelector('[data-url="mode=model"]');
    const productButton = document.querySelector('[data-url="mode=product"]');
    
    if (modelButton && productButton) {
      if (currentMode === 'model') {
        // Model mode is active, show the "Item View" button (to switch to product)
        modelButton.style.display = 'none';
        productButton.style.display = 'block';
      } else {
        // Product mode is active (or no mode), show the "Model View" button (to switch to model)
        modelButton.style.display = 'block';
        productButton.style.display = 'none';
      }
    }
  }

   // Handle button clicks to switch views
   function handleViewModeButtonClick(event) {
    event.preventDefault();
    // console.log('View-mode button clicked:', event.currentTarget);

    const button = event.currentTarget;
    const modeParam = button.getAttribute('data-url');
    // console.log('modeParam:', modeParam);

    if (modeParam) {
      // Update the URL without a page reload
      const url = new URL(window.location);
      url.searchParams.set('mode', modeParam.split('=')[1]);
      window.history.pushState({}, '', url);

      // Trigger class + button update
      handleCollectionViewMode();

      // Re-order / re-init sliders
      const mode = modeParam.split('=')[1];
      // console.log('Calling reorderProductImages with mode:', mode);
      reorderProductImages(mode);

      // Track View Mode Toggle and behavior after (e.g. product link click)
      // Store in sessionStorage
      sessionStorage.setItem('currentViewMode', mode);
      // Store in localStorage
      localStorage.setItem('currentViewMode', mode);

      // Push to GA4
      gtag('event', 'toggle_view', {
        view_mode: mode
      });
    }
  }

  // Track product link clicks + view mode (to track product link clicks)
  const viewModeButtons = document.querySelectorAll('.popout__toggle');
  // Only proceed if View Mode buttons are present (i.e., Collection page)
  if (viewModeButtons.length > 0) {
    document.querySelectorAll('.product-link').forEach(link => {
      link.addEventListener('click', function () {
        const productUrl = this.getAttribute('href');
        const viewMode = sessionStorage.getItem('currentViewMode') || 'unknown';

        // Push to GA4 
        gtag('event', 'collection_product_click', {
          product_url: productUrl,
          view_mode: viewMode
        });
      });
    });
  }

  // Reorder product images for model / product view and re-initialise sliders
  function reorderProductImages(mode) {
    // console.log('reorderProductImages called with mode:', mode);

    const hoverImages = document.querySelectorAll('hover-images');
    // console.log('hover-images found:', hoverImages.length);

    hoverImages.forEach((hoverImage, idx) => {
      const slider = hoverImage.querySelector('[data-hover-slider]');
      // console.log(`slider for hoverImage[${idx}] exists:`, !!slider);
      if (!slider) return;

      const slides = Array.from(slider.querySelectorAll('[data-hover-slide]'));
      // console.log(`slides count for hoverImage[${idx}]:`, slides.length);
      if (slides.length === 0) {
        // console.log(`No secondary slide for hoverImage[${idx}], skipping`);
        return;
      }

      if (mode === 'model') {
        // bring secondary image (slides[0]) to the front
        const target = slides[0];
        if (target) {
          slider.insertBefore(target, slider.firstElementChild);
          // console.log(`Moved first secondary slide to front for hoverImage[${idx}]`);
        }
      } else {
        // reset: move first slide to end
        const first = slider.querySelector('[data-hover-slide]');
        if (first) {
          slider.appendChild(first);
          // console.log(`Moved first slide to end for hoverImage[${idx}]`);
        }
      }

      // re-initialise Flickity / touch scroll logic
      if (typeof hoverImage.reinit === 'function') {
        // console.log(`Calling reinit() on hoverImage[${idx}]`);
        hoverImage.reinit();

        // After reinit, ensure slider starts at first image
        if (hoverImage.flkty) {
          // Flickity instance present (desktop)
          hoverImage.flkty.select(0, false, true);
        }
      }

      // Always reset scroll/CSS variable for touch devices
      if (slider) {
        slider.scrollLeft = 0;
      }
      hoverImage.style.setProperty('--slider-index', 0);
    });
  }

  

  // Initialize view mode buttons
  function initializeViewModeButtons() {
    const viewModeButtons = document.querySelectorAll('[data-url^="mode="]');
    
    viewModeButtons.forEach(button => {
      button.addEventListener('click', handleViewModeButtonClick);
    });
  }

  // Run on page load
  handleCollectionViewMode();
  initializeViewModeButtons();

  // Ensure correct image order on initial load if landing directly in model mode
  // or if view mode was automatically restored from session storage
  const initialMode = new URLSearchParams(window.location.search).get('mode');
  if (initialMode === 'model') {
    reorderProductImages('model');
  } else if (initialMode === 'product') {
    reorderProductImages('product');
  }

  // Also run when the URL changes (for single-page navigation)
  window.addEventListener('popstate', handleCollectionViewMode);
    
})();
